(function () {
  var IS_EDITOR = !!(window.Shopify && window.Shopify.designMode);
  var MOBILE_ZOOM_LOCK_CLASS = "sb-zoom-locked";

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function isMobileZoomLockViewport() {
    try { return window.matchMedia("(max-width: 749px)").matches; } catch (_) {}
    return (window.innerWidth || 0) <= 749;
  }

  function shouldLockMobileZoomPage() {
    if (!isMobileZoomLockViewport()) return false;
    try {
      var anySingle = document.querySelector("[data-sb-wall].is-single");
      return !!anySingle;
    } catch (_) {}
    return false;
  }

  function lockMobileZoomPage() {
    var html = document.documentElement;
    var body = document.body;
    if (!html || !body) return;
    if (html.classList.contains(MOBILE_ZOOM_LOCK_CLASS) && body.classList.contains(MOBILE_ZOOM_LOCK_CLASS)) return;
    try { window.scrollTo(0, 0); } catch (_) {}
    html.classList.add(MOBILE_ZOOM_LOCK_CLASS);
    body.classList.add(MOBILE_ZOOM_LOCK_CLASS);
  }

  function unlockMobileZoomPage() {
    var html = document.documentElement;
    var body = document.body;
    if (!html && !body) return;
    if (html) {
      html.classList.remove(MOBILE_ZOOM_LOCK_CLASS);
    }
    if (body) body.classList.remove(MOBILE_ZOOM_LOCK_CLASS);
  }

  function syncGlobalMobileZoomPageLock() {
    if (IS_EDITOR) return;
    if (shouldLockMobileZoomPage()) lockMobileZoomPage();
    else unlockMobileZoomPage();
  }

  // Grid fitting
  function fitRectInside(tileW, tileH, aspect) {
    var w = tileW, h = w / aspect;
    if (h > tileH) { h = tileH; w = h * aspect; }
    return { area: w * h };
  }

  function candidatesForCount(n) {
    if (n === 3) return [{ cols: 3, rows: 1 }, { cols: 1, rows: 3 }];
    if (n === 4) return [{ cols: 2, rows: 2 }, { cols: 4, rows: 1 }, { cols: 1, rows: 4 }];
    if (n === 5) return [{ cols: 5, rows: 1 }, { cols: 1, rows: 5 }];
    var out = [], maxCols = Math.min(n, 6);
    for (var cols = 1; cols <= maxCols; cols++) out.push({ cols: cols, rows: Math.ceil(n / cols) });
    return out;
  }

  function chooseGrid(n, W, H, aspect) {
    var cands = candidatesForCount(n);
    var best = { cols: 1, rows: n, score: -Infinity };
    for (var i = 0; i < cands.length; i++) {
      var cols = cands[i].cols, rows = cands[i].rows;
      var tileW = W / cols, tileH = H / rows;
      var area = fitRectInside(tileW, tileH, aspect).area;
      var empty = cols * rows - n;
      var lineBonus = (n <= 5 && (rows === 1 || cols === 1)) ? 1.06 : 1.0;
      var score = area * (1 - empty * 0.12) * lineBonus;
      if (score > best.score) best = { cols: cols, rows: rows, score: score };
    }
    return best;
  }

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return false;
    if (r.bottom < -20 || r.top > (window.innerHeight + 20)) return false;
    if (r.right < -20 || r.left > (window.innerWidth + 20)) return false;
    var cs = window.getComputedStyle(el);
    if (cs.display === "none" || cs.visibility === "hidden" || cs.opacity === "0") return false;
    return true;
  }

  function pickCartIcon(header) {
    var icons =
      header.querySelector(".header__icons") ||
      (header.querySelector(".header__icon") ? header.querySelector(".header__icon").closest(".header__icons") : null) ||
      header;

    var candidates = [];
    var a = icons.querySelectorAll(
      "#cart-icon-bubble, .header__icon--cart, a[href='/cart'], a[href^='/cart?'], a[href*='/cart']"
    );
    for (var i = 0; i < a.length; i++) candidates.push(a[i]);

    var best = null;
    var bestScore = -1;

    for (var j = 0; j < candidates.length; j++) {
      var el = candidates[j];
      if (!isVisible(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.top > 220) continue;

      var score = (r.width * r.height);
      if (score > bestScore) { bestScore = score; best = el; }
    }

    return best;
  }

  function init(root) {
    if (root.__sbInit) return;
    root.__sbInit = true;

    var top = root.querySelector("[data-sb-top]");
    var titleEl = top ? top.querySelector(".sb-wall-top__title") : null;
    var list = root.querySelector("[data-sb-list]");
    var overlay = root.querySelector("[data-sb-overlay]");
    if (!list) return;

    var tiles = Array.prototype.slice.call(list.querySelectorAll(".sb-fitgrid__tile"));
    var zoomToggle = root.querySelector("[data-zoom-toggle]");
    var tileCarousels = [];

    // --- Animation control flags ---
    var isAnimating = false;
    var skipScrollReset = false;

    function getMode() {
      return root.classList.contains("is-single") ? "single" : "overview";
    }

    function getSingleIndexFromScroll() {
      var n = tiles.length || 0;
      if (!n) return 0;
      var pageH = Math.max(1, list.getBoundingClientRect().height || list.clientHeight || 1);
      return clamp(Math.round((list.scrollTop || 0) / pageH), 0, n - 1);
    }

    function initTileImageCarousels() {
      tileCarousels = [];

      for (var i = 0; i < tiles.length; i++) {
        (function (tile) {
          var media = tile.querySelector(".sb-fitgrid__media");
          var track = tile.querySelector("[data-sb-img-track]");
          var slides = tile.querySelectorAll("[data-sb-img-slide]");
          var prevBtn = tile.querySelector("[data-sb-img-prev]");
          var nextBtn = tile.querySelector("[data-sb-img-next]");

          if (!media || !track) return;

          function getMaxScrollLeft() {
            return Math.max(0, (track.scrollWidth || 0) - (track.clientWidth || 0));
          }

          function setEdges() {
            var isSingle = getMode() === "single";
            var hasMany = slides && slides.length > 1;
            var sl = track.scrollLeft || 0;
            var max = getMaxScrollLeft();
            var tol = 4;
            var atLeft = !isSingle || !hasMany || sl <= tol;
            var atRight = !isSingle || !hasMany || sl >= (max - tol);

            media.classList.toggle("is-img-edge-left", !!atLeft);
            media.classList.toggle("is-img-edge-right", !!atRight);

            if (prevBtn) prevBtn.disabled = !!atLeft;
            if (nextBtn) nextBtn.disabled = !!atRight;
          }

          function scrollStep(dir) {
            if (getMode() !== "single") return;
            if (!slides || slides.length <= 1) return;
            var step = Math.max(1, track.clientWidth || 1);
            var delta = (dir > 0 ? step : -step);
            try {
              track.scrollBy({ left: delta, top: 0, behavior: "smooth" });
            } catch (_) {
              track.scrollLeft = (track.scrollLeft || 0) + delta;
            }
          }

          function onPrev(e) {
            try { e.preventDefault(); } catch (_) {}
            try { e.stopPropagation(); } catch (_) {}
            scrollStep(-1);
          }

          function onNext(e) {
            try { e.preventDefault(); } catch (_) {}
            try { e.stopPropagation(); } catch (_) {}
            scrollStep(1);
          }

          function swallowNavPress(e) {
            // Prevent nested <button> inside tile link from triggering the product overlay.
            try { e.stopPropagation(); } catch (_) {}
          }

          if (prevBtn) {
            prevBtn.addEventListener("pointerdown", swallowNavPress);
            prevBtn.addEventListener("mousedown", swallowNavPress);
            prevBtn.addEventListener("touchstart", swallowNavPress, { passive: true });
          }
          if (nextBtn) {
            nextBtn.addEventListener("pointerdown", swallowNavPress);
            nextBtn.addEventListener("mousedown", swallowNavPress);
            nextBtn.addEventListener("touchstart", swallowNavPress, { passive: true });
          }
          if (prevBtn) prevBtn.addEventListener("click", onPrev);
          if (nextBtn) nextBtn.addEventListener("click", onNext);
          track.addEventListener("scroll", setEdges, { passive: true });

          tileCarousels.push({
            track: track,
            setEdges: setEdges,
            reset: function () {
              try { track.scrollLeft = 0; } catch (_) {}
              setEdges();
            }
          });

          setEdges();
        })(tiles[i]);
      }
    }

    function syncTileImageCarousels(resetToFirst) {
      for (var i = 0; i < tileCarousels.length; i++) {
        var c = tileCarousels[i];
        if (!c) continue;
        if (resetToFirst && typeof c.reset === "function") c.reset();
        else if (typeof c.setEdges === "function") c.setEdges();
      }
    }

    function layout() {
      var n = Math.max(tiles.length, 1);
      var topH = top ? Math.ceil(top.getBoundingClientRect().height) : 0;
      var viewportH = Math.max(
        1,
        (window.visualViewport && window.visualViewport.height) || window.innerHeight || 1
      );
      var rootRect = root.getBoundingClientRect ? root.getBoundingClientRect() : null;
      var rootTop = rootRect ? Math.max(0, rootRect.top || 0) : 0;
      var wallH = Math.max(240, Math.floor(viewportH - rootTop));
      var H = Math.max(240, (viewportH - topH - 12 - 16) * 0.8);
      var W = Math.max(240, list.getBoundingClientRect().width);

      root.style.setProperty("--sb-wall-h", wallH + "px");
      root.style.setProperty("--sb-grid-h", H + "px");

      if (getMode() === "single") {
        root.style.setProperty("--sb-cols", "1");
        root.style.setProperty("--sb-rows", "1");
        return;
      }

      // Mobile overview MUST be 1 col / N rows
      var isMobile = window.matchMedia("(max-width: 749px)").matches;
      if (isMobile) {
        root.style.setProperty("--sb-cols", "1");
        root.style.setProperty("--sb-rows", String(n));
        return;
      }

      var res = chooseGrid(n, W, H, 0.8);
      root.style.setProperty("--sb-cols", String(res.cols));
      root.style.setProperty("--sb-rows", String(res.rows));
    }

    // Align the zoom button center under cart icon center
    function alignToggleUnderCart(cartRect) {
      if (!zoomToggle) return;

      zoomToggle.style.transform = "translateX(0px)";

      var toggleRect = zoomToggle.getBoundingClientRect();
      var cartCenterX = cartRect.left + cartRect.width / 2;
      var toggleCenterX = toggleRect.left + toggleRect.width / 2;

      var dx = cartCenterX - toggleCenterX;
      dx = clamp(dx, -320, 320);

      zoomToggle.style.transform = "translateX(" + dx + "px)";
    }

    // Mirror the zoom button gutter exactly:
    // title left edge distance from viewport left === zoom button right edge distance from viewport right
    function alignTitleToMirroredToggleGutter(cartRect) {
      if (!titleEl) return;

      titleEl.style.transform = "translateX(0px)";

      var titleRect = titleEl.getBoundingClientRect();
      var dx = 0;

      if (zoomToggle) {
        var toggleRectForGutter = zoomToggle.getBoundingClientRect();
        var mirroredLeftGutter = Math.max(0, window.innerWidth - toggleRectForGutter.right);
        dx = mirroredLeftGutter - titleRect.left;
      } else {
        // Fallback if the zoom toggle isn't present for any reason.
        var cartCenterX = cartRect.left + cartRect.width / 2;
        var targetTitleCenterX = window.innerWidth - cartCenterX;
        var titleCenterX = titleRect.left + titleRect.width / 2;
        dx = targetTitleCenterX - titleCenterX;
      }

      dx = clamp(dx, -400, 400);

      if (zoomToggle) {
        var toggleRect = zoomToggle.getBoundingClientRect();
        var movedTitleRight = titleRect.right + dx;
        var minGap = 12;
        if (movedTitleRight + minGap > toggleRect.left) {
          dx -= (movedTitleRight + minGap - toggleRect.left);
        }
      }

      titleEl.style.transform = "translateX(" + dx + "px)";
    }

    function alignHeaderGeometry() {
      var header = document.querySelector("header");
      if (!header) return;

      var cart = pickCartIcon(header);
      if (!cart) return;

      var cartRect = cart.getBoundingClientRect();
      alignToggleUnderCart(cartRect);
      alignTitleToMirroredToggleGutter(cartRect);
    }

    // --- MODE SETTER (patched) ---
    function setMode(mode) {
      if (mode === "single") {
        root.classList.add("is-single");
        try { localStorage.setItem("sb_wall_mode", "single"); } catch (_) {}
      } else {
        root.classList.remove("is-single");
        try { localStorage.setItem("sb_wall_mode", "overview"); } catch (_) {}
      }

      // IMPORTANT: do not force scrollTop reset during animation
      if (!skipScrollReset) {
        try {
          list.scrollTop = 0;
          list.scrollLeft = 0;
        } catch (_) {}
      }

      layout();
      if (!isAnimating) syncGlobalMobileZoomPageLock();
      requestAnimationFrame(alignHeaderGeometry);
      requestAnimationFrame(function () { syncTileImageCarousels(true); });

      if (zoomToggle) {
        if (getMode() === "single") zoomToggle.classList.add("is-active");
        else zoomToggle.classList.remove("is-active");
      }
    }

    // --- Animation helpers (patched) ---
    function getFocusedIndex() {
      var n = tiles.length;
      if (!n) return 0;

      // In single mode, pick snap page closest to current scroll
      if (getMode() === "single") {
        return getSingleIndexFromScroll();
      }

      // In overview, pick tile closest to list center (not window center)
      var listRect = list.getBoundingClientRect();
      var cx = listRect.left + listRect.width / 2;
      var cy = listRect.top + listRect.height / 2;

      var bestI = 0;
      var bestD = Infinity;

      for (var i = 0; i < n; i++) {
        var r = tiles[i].getBoundingClientRect();
        if (r.width <= 0 || r.height <= 0) continue;
        var tx = r.left + r.width / 2;
        var ty = r.top + r.height / 2;
        var d = Math.abs(tx - cx) + Math.abs(ty - cy);
        if (d < bestD) { bestD = d; bestI = i; }
      }
      return bestI;
    }

    function getMediaRectForTile(tile) {
      if (!tile) return null;
      var media = tile.querySelector(".sb-fitgrid__media") || tile;
      var r = media.getBoundingClientRect();
      if (!r || r.width <= 0 || r.height <= 0) return null;
      return { el: media, rect: r };
    }

    function getPriceRectForTile(tile) {
      if (!tile) return null;
      var price = tile.querySelector(".sb-fitgrid__price");
      if (!price) return null;
      var r = price.getBoundingClientRect();
      if (!r || r.width <= 0 || r.height <= 0) return null;
      return { el: price, rect: r };
    }

  function makeFixedClone(mediaEl, rect) {
  var cs = window.getComputedStyle(mediaEl);
  var img = null;

  try {
    var trackEl = mediaEl.querySelector("[data-sb-img-track]");
    if (trackEl) {
      var slides = trackEl.querySelectorAll("[data-sb-img-slide]");
      if (slides && slides.length) {
        var step = Math.max(1, Math.round(trackEl.clientWidth || mediaEl.clientWidth || 1));
        var idx = clamp(Math.round((trackEl.scrollLeft || 0) / step), 0, slides.length - 1);
        var activeSlide = slides[idx] || slides[0];
        if (activeSlide) img = activeSlide.querySelector("img") || activeSlide.querySelector("picture img");
      }
    }
  } catch (_) {}

  if (!img) img = mediaEl.querySelector("img") || mediaEl.querySelector("picture img");

  var wrap = document.createElement("div");
  wrap.className = "sb-zoom-clone";
  wrap.style.position = "fixed";
  // Keep sub-pixel precision so the clone lands exactly on the target rect.
  wrap.style.left = rect.left + "px";
  wrap.style.top = rect.top + "px";
  wrap.style.width = rect.width + "px";
  wrap.style.height = rect.height + "px";
  wrap.style.zIndex = "9998";
  wrap.style.overflow = "hidden";
  wrap.style.boxSizing = "border-box";
  wrap.style.background = cs.backgroundColor || "#fff";
  wrap.style.borderRadius = cs.borderRadius || "0px";
  wrap.style.border = cs.border || "none";
  wrap.style.boxShadow = cs.boxShadow || "none";
  wrap.style.transformOrigin = "center center";
  wrap.style.willChange = "left, top, width, height, border-radius";
  wrap.style.pointerEvents = "none";
  wrap.style.backfaceVisibility = "hidden";
  wrap.style.webkitBackfaceVisibility = "hidden";

  if (img) {
    var cloneImg = document.createElement("img");
    cloneImg.alt = "";
    cloneImg.decoding = "async";
    cloneImg.src = img.currentSrc || img.src;
    cloneImg.style.width = "100%";
    cloneImg.style.height = "100%";
    cloneImg.style.display = "block";
    cloneImg.style.objectFit = window.getComputedStyle(img).objectFit || "cover";
    cloneImg.style.transform = "translateZ(0)";
    wrap.appendChild(cloneImg);
  }

  // iOS Safari: fixed elements are more reliable when appended to <html>
  (document.documentElement || document.body).appendChild(wrap);
  return wrap;
}

    function makePriceGhostClone(priceEl, rect) {
  if (!priceEl || !rect) return null;
  var textValue = "";
  try { textValue = (priceEl.textContent || "").trim(); } catch (_) { textValue = ""; }
  if (!textValue) return null;

  var cs = window.getComputedStyle(priceEl);
  var ghost = document.createElement("div");
  ghost.className = "sb-zoom-price-clone";
  ghost.style.position = "fixed";
  ghost.style.left = rect.left + "px";
  ghost.style.top = rect.top + "px";
  ghost.style.width = rect.width + "px";
  ghost.style.height = rect.height + "px";
  ghost.style.zIndex = "10000";
  ghost.style.pointerEvents = "none";
  ghost.style.boxSizing = "border-box";
  ghost.style.display = "flex";
  ghost.style.alignItems = "center";
  ghost.style.justifyContent = "center";
  ghost.style.borderRadius = "0px";
  ghost.style.background = "transparent";
  ghost.style.opacity = "0.88";
  ghost.style.transform = "translate3d(0,0,0) scale(1,1)";
  ghost.style.transformOrigin = "center center";
  ghost.style.backfaceVisibility = "hidden";
  ghost.style.webkitBackfaceVisibility = "hidden";
  ghost.style.willChange = "transform, opacity";

  var text = document.createElement("span");
  text.textContent = textValue;
  text.style.display = "block";
  text.style.color = "rgba(0,0,0,0.98)";
  text.style.fontFamily = cs.fontFamily || "inherit";
  text.style.fontSize = cs.fontSize || "16px";
  text.style.fontWeight = cs.fontWeight || "700";
  text.style.lineHeight = cs.lineHeight || "1";
  text.style.letterSpacing = cs.letterSpacing || "0";
  text.style.textTransform = cs.textTransform || "none";
  text.style.whiteSpace = "nowrap";
  text.style.webkitFontSmoothing = "antialiased";
  text.style.transform = "translateZ(0)";
  ghost.appendChild(text);

  try {
    if (cs && cs.borderRadius && cs.borderRadius !== "0px") {
      ghost.style.borderRadius = cs.borderRadius;
    }
  } catch (_) {}

  (document.documentElement || document.body).appendChild(ghost);
  return ghost;
}

    function animateSwitch(toMode) {
  if (isAnimating) return;

  var fromMode = getMode();
  if (fromMode === toMode) return;

  // Prefer-reduced-motion: keep instant
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    setMode(toMode);
    return;
  }

  var idx = getFocusedIndex();
  var fromMedia = getMediaRectForTile(tiles[idx]);
  var fromPrice = getPriceRectForTile(tiles[idx]);
  if (!fromMedia) { setMode(toMode); return; }

  isAnimating = true;
  root.classList.add("is-animating");

  // Hide real content instantly (clone stays visible)
  list.style.pointerEvents = "none";
  list.style.transition = "";
  list.style.opacity = "0";

  // Force the opacity state to commit BEFORE we switch modes (prevents flicker/glitch)
  void list.offsetHeight;

  var clone = makeFixedClone(fromMedia.el, fromMedia.rect);
  var priceClone = fromPrice ? makePriceGhostClone(fromPrice.el, fromPrice.rect) : null;

  // Switch mode/layout while hidden, without scroll reset
  skipScrollReset = true;
  setMode(toMode);
  skipScrollReset = false;

  // Fallback: if Web Animations API is missing/buggy on mobile, just switch cleanly
 if (!clone || typeof clone.animate !== "function") {
  list.style.transition = "";
  list.style.opacity = "1";
  requestAnimationFrame(function () {
    try { if (clone) clone.remove(); } catch (_) {}
    try { if (priceClone) priceClone.remove(); } catch (_) {}
    list.style.opacity = "";
    list.style.pointerEvents = "";
    root.classList.remove("is-animating");
    isAnimating = false;
    syncGlobalMobileZoomPageLock();
  });
  return;
}

  requestAnimationFrame(function () {
    // Keep the same item in view ONLY for single mode.
    // IMPORTANT: do NOT scrollIntoView on overview (can scroll the whole page).
    try {
      if (toMode === "single") {
        var pageH = Math.max(1, list.getBoundingClientRect().height);
        list.scrollTop = idx * pageH;
        list.scrollLeft = 0;
      }
    } catch (_) {}

    // Measure target rect after layout switch
    var toMedia = getMediaRectForTile(tiles[idx]);
    var toPrice = getPriceRectForTile(tiles[idx]);
    if (!toMedia) {
      try { clone.remove(); } catch (_) {}
      try { if (priceClone) priceClone.remove(); } catch (_) {}
      list.style.opacity = "";
      list.style.transition = "";
      list.style.pointerEvents = "";
      root.classList.remove("is-animating");
      isAnimating = false;
      return;
    }

    // Measure the clone itself (not the original rect object) so scale math
    // matches the actual rendered start size/position exactly.
    var a = clone.getBoundingClientRect();
    var b = toMedia.rect;

    var fromRadius = "";
    var toRadius = "";
    try { fromRadius = window.getComputedStyle(fromMedia.el).borderRadius || "0px"; } catch (_) { fromRadius = "0px"; }
    try { toRadius = window.getComputedStyle(toMedia.el).borderRadius || fromRadius || "0px"; } catch (_) { toRadius = fromRadius || "0px"; }

    var anim = clone.animate(
      [
        {
          left: a.left + "px",
          top: a.top + "px",
          width: a.width + "px",
          height: a.height + "px",
          borderRadius: fromRadius,
          opacity: 1
        },
        {
          left: b.left + "px",
          top: b.top + "px",
          width: b.width + "px",
          height: b.height + "px",
          borderRadius: toRadius,
          opacity: 1
        }
      ],
      { duration: 260, easing: "cubic-bezier(0.2, 0.8, 0.2, 1)", fill: "forwards" }
    );

    var priceAnim = null;
    if (priceClone && toPrice && typeof priceClone.animate === "function") {
      var pcStart = priceClone.getBoundingClientRect();
      var pcEnd = toPrice.rect;
      var pdx = (pcEnd.left + pcEnd.width / 2) - (pcStart.left + pcStart.width / 2);
      var pdy = (pcEnd.top + pcEnd.height / 2) - (pcStart.top + pcStart.height / 2);
      var psx = pcEnd.width / Math.max(1, pcStart.width);
      var psy = pcEnd.height / Math.max(1, pcStart.height);
      priceAnim = priceClone.animate(
        [
          {
            transform: "translate3d(0px, 0px, 0) scale(1, 1)",
            opacity: 0.88
          },
          {
            transform: "translate3d(" + pdx + "px, " + pdy + "px, 0) scale(" + psx + ", " + psy + ")",
            opacity: 0.88
          }
        ],
        { duration: 260, easing: "cubic-bezier(0.2, 0.8, 0.2, 1)", fill: "forwards" }
      );
    }

    var didCleanup = false;
    function cleanup() {
      if (didCleanup) return;
      didCleanup = true;

      // Remove clone first, then reveal real content in the same frame.
      // This avoids a one-frame overlap mismatch that can look like a width pop.
      try { clone.remove(); } catch (_) {}
      try { if (priceClone) priceClone.remove(); } catch (_) {}
      list.style.transition = "";
      list.style.opacity = "1";

      // Next frame: clear temp styles + re-enable interactions
      requestAnimationFrame(function () {
        list.style.opacity = "";
        list.style.pointerEvents = "";
        root.classList.remove("is-animating");
        isAnimating = false;
        syncGlobalMobileZoomPageLock();
      });
    }

    var remainingAnims = priceAnim ? 2 : 1;
    function finishOneAnim() {
      if (didCleanup) return;
      remainingAnims -= 1;
      if (remainingAnims > 0) return;
      cleanup();
    }

    anim.onfinish = finishOneAnim;
    anim.oncancel = finishOneAnim;
    if (priceAnim) {
      priceAnim.onfinish = finishOneAnim;
      priceAnim.oncancel = finishOneAnim;
    }
  });
}

    // Persist mode
    try {
      var saved = localStorage.getItem("sb_wall_mode");
      if (saved === "single") root.classList.add("is-single");
    } catch (_) {}

    // Toggle click
    if (zoomToggle) {
  if (getMode() === "single") zoomToggle.classList.add("is-active");

  function onToggle(e) {
    // Mobile reliability + prevents weird focus/scroll side-effects
    if (e) {
      try { e.preventDefault(); } catch (_) {}
      try { e.stopPropagation(); } catch (_) {}
    }
    var nextMode = getMode() === "overview" ? "single" : "overview";
    if (nextMode === "single") lockMobileZoomPage();
    animateSwitch(nextMode);
  }

  // Pointer events are the most reliable on mobile + desktop
  zoomToggle.addEventListener("pointerup", onToggle, { passive: false });

  // Fallbacks (some browsers still only trigger click/touch)
  zoomToggle.addEventListener("touchend", onToggle, { passive: false });
  zoomToggle.addEventListener("click", onToggle);
}

    var tileCarouselRAF = 0;
    function scheduleTileCarouselSync(resetToFirst) {
      if (tileCarouselRAF) return;
      tileCarouselRAF = requestAnimationFrame(function () {
        tileCarouselRAF = 0;
        syncTileImageCarousels(!!resetToFirst);
      });
    }

    initTileImageCarousels();

    // Initial
    layout();
    syncGlobalMobileZoomPageLock();
    scheduleTileCarouselSync(true);

    // Align once header finishes shifting
    requestAnimationFrame(alignHeaderGeometry);
    setTimeout(alignHeaderGeometry, 0);
    setTimeout(alignHeaderGeometry, 60);
    setTimeout(alignHeaderGeometry, 200);
    setTimeout(alignHeaderGeometry, 500);

    // Resize hooks
    function onResize() {
      layout();
      syncGlobalMobileZoomPageLock();
      requestAnimationFrame(alignHeaderGeometry);
      scheduleTileCarouselSync(false);
    }

    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    if (window.visualViewport) window.visualViewport.addEventListener("resize", onResize);

    // Legacy overlay disabled
    if (overlay) {
      overlay.hidden = true;
      overlay.style.display = "none";
    }
  }

  function boot() {
    var walls = document.querySelectorAll("[data-sb-wall]");
    for (var i = 0; i < walls.length; i++) {
      try { init(walls[i]); } catch (err) {}
    }
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    try {
      var r = e.target.querySelector("[data-sb-wall]");
      if (r) init(r);
    } catch (err) {}
  });
})();
